<script>
import { mapState, mapActions } from 'vuex';
/* import { getAsset } from '@/scripts/utils'; */
import { mobile } from '@/scripts/computed';

export default {
  name: 'TabsSlider',
  components: {},
  props: {
    count: {
      test: Number,
      required: !true,
    },
  },
  data() {
    return {
      slideIndex: 0,
      maxIndex: 0,
      activeSlider: null,
      contentWidth: null,
    };
  },
  computed: {
    ...mapState([]),

    transform() {
      const { activeSlider } = this;

      if (!activeSlider) return '';

      const move = this.slideIndex * this.getStepWidth();
      const result = `translate3d(-${move}px, 0, 0)`;

      return result;
    },
    mobile,
  },
  created() {},
  mounted() {
    window.addEventListener('resize', this.resize);

    this.resize();
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    ...mapActions({}),
    getStepWidth() {
      const { $refs: refs } = this;
      const { content } = refs;

      if (!content) return 0;

      const slides = content.querySelectorAll('.slide');
      const [, slide] = slides;

      const styles = getComputedStyle(slide);
      const { width, marginLeft, marginRight } = styles;
      const size =
        parseFloat(width) + parseFloat(marginLeft) + parseFloat(marginRight);

      const result = size;

      return result;
    },
    nextSlide() {
      const { slideIndex, maxIndex } = this;
      const nextSlide = slideIndex + 1;

      if (maxIndex < nextSlide) return;

      this.slideIndex = nextSlide;
    },
    backSlide() {
      const { slideIndex } = this;

      if (!slideIndex) return;

      this.slideIndex = slideIndex - 1;
    },
    resize() {
      const { mobile, $refs: refs } = this;
      const { space, content } = refs;
      const spaceWidth = space.offsetWidth;
      const contentWidth = content.offsetWidth;
      const result = contentWidth > spaceWidth && !mobile;

      this.activeSlider = result;
      this.contentWidth = contentWidth;

      const maxIndex = Math.ceil(
        (contentWidth - spaceWidth) / this.getStepWidth()
      );

      this.maxIndex = maxIndex;
    },
  },
};
</script>

<template>
  <div
    :class="{
      tabs: true,
      active: activeSlider,
      scroll: mobile,
    }"
    ref="space"
  >
    <div
      :class="{
        tabs__btn: true,
        'tabs__btn--back': true,
        disable: !slideIndex,
      }"
      @click="backSlide()"
    >
      <img :src="require('@/assets/svg/play.svg')" />
    </div>
    <div class="tabs__track" :style="{ transform }">
      <div class="tabs__wrapper" ref="content">
        <!-- > -->
        <slot />
        <!-- < -->
      </div>
    </div>
    <div
      :class="{
        tabs__btn: true,
        'tabs__btn--next': true,
        disable: slideIndex === maxIndex,
      }"
      @click="nextSlide()"
    >
      <img :src="require('@/assets/svg/play.svg')" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.tabs {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &__track {
    display: flex;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateZ(0);
    transition: transform 0.4s;
    transform: translate3d(0px, 0px, 0px);
  }

  &__btn {
    position: relative;
    display: none;
    align-items: center;
    justify-content: flex-start;
    transition: all 0.2s;
    width: 29px;
    height: 60px;
    flex-shrink: 0;
    z-index: 1;
    background: rgba(25, 22, 52, 0.21);
    cursor: pointer;
    user-select: none;

    img {
      width: 13px;
      height: 16px;
    }

    &--next {
      justify-content: flex-end;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%) scale(-1, 1);
    }

    &.disable {
      pointer-events: none;
      user-select: none;
      opacity: 0.5;
    }
  }

  &__wrapper {
    display: flex;
    align-items: center;
    margin-left: -10px;
  }

  &.active {
    display: flex;
    align-items: center;

    .tabs__track {
      padding: 0 10px;
    }

    .tabs__wrapper {
      margin-left: 0;
    }

    .tabs__btn {
      display: flex;
    }
  }

  &.scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .tabs__wrapper {
      padding: 0 5px 0 5px;
      margin-left: 0;
    }
  }
}
</style>
